export const openExternalUrl = (url, { target = '_blank' } = {}) => {
  if (!url || typeof window === 'undefined') return null;
  if (target === '_blank') {
    return window.open(url, target, 'noopener,noreferrer');
  }
  return window.open(url, target);
};

export const openBlankTab = () => {
  if (typeof window === 'undefined') return null;
  const handle = window.open('', '_blank');
  if (!handle) return null;
  try {
    handle.opener = null;
  } catch (_) {
    // noop
  }
  return handle;
};
